import React, { useState, useEffect } from 'react'
import { createStructuredSelector } from 'reselect'
import { branch, renderComponent } from 'recompose'
import classNames from 'classnames'

import { withTranslate } from 'i18n/utils'

import { CardSection } from 'shared/components/CardSection'
import { VehicleTabs } from 'shared/components/VehicleTabs'
import ErrorMessage from 'shared/components/ErrorMessage'
import Button from 'shared/components/Button'
import VehicleFormModal from 'shared/components/VehicleFormModal'
import LoginSignUpContainer from 'shared/components/LoginSignUpContainer'
import useBookingValidation from 'shared/hooks/useBookingValidation'
import { sendAmplitudeEvent, useSendGTAGEvent } from 'analytics/utils'

import { selectVehicle, enableCard } from 'booking/actions'
import { CARDS } from 'booking/reducers'
import { vehiclesSelector, selectedSeasonTicketSelector } from 'booking/selectors'
import { userSelector } from 'auth/selectors'

import styles from './styles.module.scss'

const $VehicleSelection = ({
    userVehicles,
    onNext,
    setVehicle,
    translate: t,
    noLimit = false,
    selectVehicle,
    vehicles,
    rate,
    currentItemIndex,
    analyticsFlowType,
}) => {
    const [selectedVehicles, setSelectedVehicles] = useState([])
    const { updateValidation } = useBookingValidation()
    const sendGTAGEvent = useSendGTAGEvent()
    const isMultipleVehicle = rate && rate.isMultipleVehicle
    const numberOfVehicles = isMultipleVehicle ? rate.numberOfVehicles : 1

    const selectedVehicleLabel = selectedVehicles.length > 0 && selectedVehicles[0].tag

    useEffect(() => {
        updateValidation({
            selectedVehiclesError: false,
        })
    }, [vehicles, currentItemIndex, isMultipleVehicle, rate])

    useEffect(() => {
        updateValidation({
            selectedVehiclesError: false,
        })

        if (selectedVehicles && selectedVehicles.length > 0) enableCard([CARDS.PAY_FOR_PARKING])
    }, [selectedVehicles, rate])

    const onNextStep = () => {
        onNext()
        setVehicle({ ...selectedVehicles, displayValue: selectedVehicleLabel })
        selectVehicle(selectedVehicles)

        if (analyticsFlowType) {
            sendGTAGEvent('select_vehicle', { flow_type: analyticsFlowType })
            sendAmplitudeEvent('Vehicle Selected', { 'Flow Type': analyticsFlowType })
        }
    }

    return (
        <CardSection className="p-6">
            <h3 className={classNames('text-uppercase', 'font-weight-bold', styles.dateLabel)}>
                <T>booking.purchase.vehicle.label</T>
            </h3>
            {selectedVehicles.length === 0 && (isMultipleVehicle || noLimit) && (
                <ErrorMessage messages={[t('purchase.flow.vehicles.add.vehicle.warning')]} type="text" />
            )}
            <div className="d-flex flex-column">
                <VehicleTabs
                    setSelectedVehicles={setSelectedVehicles}
                    vehicles={selectedVehicles}
                    userVehicles={userVehicles}
                    maxVehicles={numberOfVehicles}
                    isVehiclesListOpen
                    canAddPlate={false}
                />

                <VehicleFormModal analyticsFlowType={analyticsFlowType} />
                <div className={classNames('row', styles.nextButtonContainer)}>
                    <Button
                        btnStyle="primary"
                        onClick={onNextStep}
                        disabled={selectedVehicles.length < 1}
                        className={styles.nextButton}>
                        <T>subscription.purchase.label.next</T>
                    </Button>
                </div>
            </div>
        </CardSection>
    )
}

const VehicleSelection = compose(
    connect(
        createStructuredSelector({
            userVehicles: vehiclesSelector,
            user: userSelector,
            selectedSeasonTicket: selectedSeasonTicketSelector,
            vehicles: vehiclesSelector,
        }),
        { selectVehicle, enableCard }
    ),
    withTranslate,
    branch(({ user }) => !user, renderComponent(LoginSignUpContainer), renderComponent($VehicleSelection))
)(VehicleSelection)

export default VehicleSelection
